import { DetailedHTMLProps, LabelHTMLAttributes } from 'react';
import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
`;

export const Label = styled.div(({ theme }) => {
  return `
    font-size: ${theme.type.size.tiny};
    color: ${theme.color.grayscale[0]};
    margin-bottom: 5px;
  `;
});

interface FormLabelProps extends DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
  display?: string;
}

export const FormLabel = styled.label<FormLabelProps>(({ theme, display }) => {
  return `
    font-size: ${theme.type.size.tiny};
    color: ${theme.color.grayscale[0]};
    margin-bottom: 5px;
    margin-right: 10px;
    display: ${display || 'block'};
  `;
});

export const SectionContent = styled.div`
  flex: 1;
`;

export const LongSectionContent = styled.div`
  flex: 2;
`;

export const RightSectionContent = styled.div`
  display: flex;
  flex: 3;
`;

export const GrayedText = styled.span(({ theme }) => {
  return `
    color: ${theme.color.grayscale[200]};
  `;
});

export const DateInput = styled.input(({ theme }) => {
  return `
    border-radius: 1000px;
    border: 1px solid ${theme.color.grayscale[600]};
    font-size: ${theme.type.size.regular};
    padding: 5px;
  `;
});

export const DataTextLarge = styled.div(({ theme }) => {
  return `
      margin-top: 10px;
      font-size: ${theme.type.size.large};
  
      &.bold {
        font-weight: ${theme.type.weight.bold};
      }

      @media (max-width: 1500px) {
        font-size: ${theme.type.size.regular};
      }
    `;
});

export const EmptyText = styled.div(({ theme }) => {
  return `
    text-align: center;
    font-weight: ${theme.type.weight.bold};
    font-size: ${theme.type.size.larger};
    width: 80px
  `;
});

export const DataText = styled.div(({ theme }) => {
  return `
      margin-top: 12px;
      font-size: ${theme.type.size.regular};
  
      &.bold {
        font-weight: ${theme.type.weight.bold};
      }
    `;
});

export const SectionTitle = styled.div(({ theme }) => {
  return `
    font-size: ${theme.type.size.regular};
    margin-bottom: 10px;
    font-weight: ${theme.type.weight.regular};
  `;
});

export const DataTextSmall = styled.div(({ theme }) => {
  return `
    font-size: ${theme.type.size.small};
  `;
});

export const Dot = styled.span(({ theme }) => {
  return `
    font-size: ${theme.type.size.tiny};
    margin-right: 5px;
    position: relative;
    top: -2px;
  `;
});
